<script setup lang="ts">
import { computed, type PropType } from 'vue'
import { MercariProductTypeEnum } from '@/types/Mercari'

const props = defineProps({
	text: {
		type: String,
		required: true,
	},
	type: {
		type: String as PropType<`${MercariProductTypeEnum}`>,
		reqired: true,
	},
})

const theme = computed(() => {
	return props.type === MercariProductTypeEnum.SOLD_OUT
		? 'bg-n-300'
		: 'bg-[#CF0C0A]'
})
</script>

<template>
	<span
		:class="`typography-c1-reg select-none rounded-sm px-[10px] py-4px text-white ${theme}`"
	>
		{{ text }}
	</span>
</template>
